import styled, { css } from 'styled-components';
export const DocumentSectionStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.grey[100]};
`;
export const DocumentViewStyled = styled.div`
  height: 244px;
  width: 100%;
  overflow: hidden;
  padding: ${({ theme }) => theme.spacings[100]};
  & * canvas {
    margin: auto;
    width: 100% !important;
    height: 240px !important;
  }

  &:first-child {
    text-align: center;
  }
`;
